module.exports = __webpack_public_path__ + "static/AS-Logo-223a9574141f0a79def274e1b0c3a819.svg";